<div role="main">
  <app-header></app-header>

  <div class="col-md-6 offset-md-1 d-flex align-items-center">
    <span class="text-white-ref ref">Reference ID</span>
    <span class="ref-id-no ms-2">{{service.referenceFileDetails.referenceId}}</span>
  </div>
  <div class="emailfooter">
    <div class="col-sm-10 col-md-10 col-lg-10 offset-md-1">
      <form [formGroup]="emailForm" (ngSubmit)="validateCode()">
        <div class="form-group mt-2 mb-2">
          <div class="d-flex align-items-center mb-2">
            <label class="text-white-ref">An Email Verification Code has been emailed to:</label> &nbsp;
            <span class="text-white-ref">{{ emailForm.get('validateEmail')?.value }}</span>
          </div>
          <div class="recaptcha-wrapper">
            <app-re-captcha (captchaEvent)="onCaptchaResolved($event)"></app-re-captcha>
          </div>

          @if (captchaValidated) {
            <div class="d-flex align-items-center mb-2">
              <label class="text-white me-2 mb-0">Enter the six-digit code in the field below and click the Submit button.</label>
              <span class="text-danger mb-0" [style.display]="invalid ? 'inline' : 'none'">Entered Code is invalid</span>
            </div>
          }

          <div class="d-flex align-items-center">
            <div class="col-sm-2 col-md-2 col-lg-2">
              <input type="text" class="form-control" id="email-code" (keypress)="enableSubmit()" (click)="enableSubmit()" placeholder="Email Code" formControlName="emailCode" name="emailCode" maxlength="6">
            </div>
            <div class="ms-2" [ngbTooltip]="!emailForm.get('emailCode')?.valid || !captchaValidated ? 'Please enter a valid 6-digit verification code and complete reCAPTCHA' : null" container="body" [tooltipClass]="'tooltip-disabled'">
              <button class="btn btn-success" type="submit" [disabled]="!emailForm.get('emailCode')?.valid || !captchaValidated">Submit</button>
            </div>
            <span class="spinner-border text-light ms-2" role="status" [style.display]="isVisible ? 'block' : 'none'"></span>
          </div>

        </div>
      </form>
    </div>


    @if (captchaValidated) {
      <div class="col-lg-11 col-md-11 col-sm-12 offset-md-1 captchaValidated">
        <div class="col container--flex">
          <button type="button" class="btn btn-warn me-2"  id="dashboardbackButton" (click)="back()">Back</button>
          <button class="btn btn-success me-2" type="submit" (click)="resendCode()">Resend Code</button>
        </div>
      </div>
    }
  </div>
  <app-footer></app-footer>
</div>
